import { render, staticRenderFns } from "./User_addmore.vue?vue&type=template&id=5534604c&style=height%3A%20100%25%3B"
import script from "./User_addmore.vue?vue&type=script&lang=js"
export * from "./User_addmore.vue?vue&type=script&lang=js"
import style0 from "./User_addmore.vue?vue&type=style&index=0&id=5534604c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports